/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PageDataGetAdminUserWalletPageListRespVo } from './PageDataGetAdminUserWalletPageListRespVo';
import {
    PageDataGetAdminUserWalletPageListRespVoFromJSON,
    PageDataGetAdminUserWalletPageListRespVoFromJSONTyped,
    PageDataGetAdminUserWalletPageListRespVoToJSON,
    PageDataGetAdminUserWalletPageListRespVoToJSONTyped,
} from './PageDataGetAdminUserWalletPageListRespVo';

/**
 * 
 * @export
 * @interface ResponsePageDataGetAdminUserWalletPageListRespVo
 */
export interface ResponsePageDataGetAdminUserWalletPageListRespVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponsePageDataGetAdminUserWalletPageListRespVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponsePageDataGetAdminUserWalletPageListRespVo
     */
    message?: string;
    /**
     * 
     * @type {PageDataGetAdminUserWalletPageListRespVo}
     * @memberof ResponsePageDataGetAdminUserWalletPageListRespVo
     */
    data?: PageDataGetAdminUserWalletPageListRespVo;
}

/**
 * Check if a given object implements the ResponsePageDataGetAdminUserWalletPageListRespVo interface.
 */
export function instanceOfResponsePageDataGetAdminUserWalletPageListRespVo(value: object): value is ResponsePageDataGetAdminUserWalletPageListRespVo {
    return true;
}

export function ResponsePageDataGetAdminUserWalletPageListRespVoFromJSON(json: any): ResponsePageDataGetAdminUserWalletPageListRespVo {
    return ResponsePageDataGetAdminUserWalletPageListRespVoFromJSONTyped(json, false);
}

export function ResponsePageDataGetAdminUserWalletPageListRespVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsePageDataGetAdminUserWalletPageListRespVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : PageDataGetAdminUserWalletPageListRespVoFromJSON(json['data']),
    };
}

export function ResponsePageDataGetAdminUserWalletPageListRespVoToJSON(json: any): ResponsePageDataGetAdminUserWalletPageListRespVo {
    return ResponsePageDataGetAdminUserWalletPageListRespVoToJSONTyped(json, false);
}

export function ResponsePageDataGetAdminUserWalletPageListRespVoToJSONTyped(value?: ResponsePageDataGetAdminUserWalletPageListRespVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': PageDataGetAdminUserWalletPageListRespVoToJSON(value['data']),
    };
}

